import { useEffect, useState } from 'react';
import { useCurrentMerchantSavedOrderId } from '@olo-web/utils/common/hooks';
import { useRouter } from 'next/router';
import { useOrder } from '@olo-web/domain/orders/queries/useOrder';
import { useCheckoutState } from '@olo-web/client-state';
import { useIsDineIn } from '@olo-web/utils/common/hooks';
import { useSavedDineInContextState } from '@olo-web/client-state';
import { useIsSplitByAmount, useTableNumFromQuery } from '@olo-web/utils/common/hooks';
import { useGoToMenu } from '@olo-web/utils/common/hooks/useGoToMenu';

export const useCheckoutRedirectToMenuCheck = () => {
  const [hasChecked, setHasChecked] = useState(false);
  const router = useRouter();
  const savedOrderId = useCurrentMerchantSavedOrderId();
  const { isLoading: isCheckingOut } = useCheckoutState();
  const tableNumFromQuery = useTableNumFromQuery();
  const isSplitByAmount = useIsSplitByAmount();
  const isDineIn = useIsDineIn();
  const dineInState = useSavedDineInContextState();
  const { orderId: orderIdFromQuery } = router.query;
  const goToMenu = useGoToMenu({ resetOrderStatus: false });
  const { isFetched, data: order } = useOrder();

  useEffect(() => {
    if (isFetched && !hasChecked) {
      if (isSplitByAmount && (tableNumFromQuery || orderIdFromQuery)) return;
      let shouldRedirect = false;
      // if no order exists redirect
      if (!savedOrderId && !dineInState && !orderIdFromQuery) shouldRedirect = true;

      if (!order?.id) shouldRedirect = true;

      // if there's no order after it has been attempted, or no items, or is complete, redirect
      const hasItems = !!order?.items?.length;
      const isAStaleCompletedOrder = !isDineIn && !!order?.orderNumber?.length && !isCheckingOut;
      shouldRedirect = !hasItems || isAStaleCompletedOrder;
      if (shouldRedirect) goToMenu();
      setHasChecked(true);
    }
  }, [
    dineInState,
    goToMenu,
    hasChecked,
    isCheckingOut,
    isDineIn,
    isFetched,
    isSplitByAmount,
    order?.id,
    order?.items?.length,
    order?.orderNumber?.length,
    orderIdFromQuery,
    savedOrderId,
    tableNumFromQuery,
  ]);
};
